// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"e_1-","scoreNumber":"e_2-","scoreStars":"e_3-","badge":"e_4-","badgeImage":"e_5-"};